module.exports = __webpack_public_path__ + "img/violet_121.92969183.png";